<template>
  <div class="file-distribution">
    <div class="page-header">
      <el-page-header @back="goBack" :content="projectName + ' - 报告下发'" />
    </div>
    
    <!-- 操作栏 -->
    <div class="action-bar">
      <el-upload
        ref="upload"
        action=""
        :auto-upload="false"
        :on-change="handleFileChange"
        :show-file-list="false"
        multiple
      >
        <el-button type="primary" icon="el-icon-upload">上传报告</el-button>
      </el-upload>
      <el-button @click="loadFileList" icon="el-icon-refresh">刷新</el-button>
    </div>

    <!-- 待匹配文件 -->
    <div class="pending-files" v-if="pendingFiles.length > 0">
      <h4>待关联文件 ({{ pendingFiles.length }})</h4>
      <el-table :data="pendingFiles" size="small">
        <el-table-column prop="name" label="文件名" min-width="200" />
        <el-table-column prop="size" label="大小" width="100">
          <template slot-scope="{ row }">{{ formatSize(row.size) }}</template>
        </el-table-column>
        <el-table-column label="关联门店" width="300">
          <template slot-scope="{ row }">
            <el-select v-model="row.storeCode" filterable placeholder="选择门店" size="small" style="width: 100%">
              <el-option v-for="store in storeOptions" :key="store.code" :label="store.name" :value="store.code" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="{ row, $index }">
            <el-button type="primary" size="mini" @click="uploadSingle(row, $index)" :loading="row.uploading">上传</el-button>
            <el-button type="text" size="mini" @click="removePending($index)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button type="success" style="margin-top: 12px" @click="uploadAll" :loading="uploadingAll">全部上传</el-button>
    </div>

    <!-- 已下发文件列表 -->
    <div class="file-list">
      <h4>已下发文件</h4>
      <el-table :data="fileList" stripe v-loading="loading">
        <el-table-column prop="fileName" label="文件名" min-width="200" />
        <el-table-column prop="storeCode" label="门店编码" width="120" />
        <el-table-column prop="storeName" label="门店名称" width="150" />
        <el-table-column prop="fileType" label="类型" width="80" />
        <el-table-column prop="fileSize" label="大小" width="100">
          <template slot-scope="{ row }">{{ formatSize(row.fileSize) }}</template>
        </el-table-column>
        <el-table-column prop="uploadTime" label="上传时间" width="160">
          <template slot-scope="{ row }">{{ formatDate(row.uploadTime) }}</template>
        </el-table-column>
        <el-table-column prop="isDownloaded" label="下载状态" width="100">
          <template slot-scope="{ row }">
            <el-tag :type="row.isDownloaded ? 'success' : 'info'" size="small">
              {{ row.isDownloaded ? '已下载' : '未下载' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="{ row }">
            <el-button type="text" @click="previewFile(row)">预览</el-button>
            <el-button type="text" style="color: #f56c6c" @click="deleteFile(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <el-pagination
        v-if="total > pageSize"
        background
        layout="prev, pager, next, total"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="page"
        @current-change="loadFileList"
        style="margin-top: 16px; text-align: right"
      />
    </div>
  </div>
</template>

<script>
import axios from 'index/axios'

export default {
  name: 'FileDistribution',
  data() {
    return {
      projectId: null,
      projectName: '项目',
      loading: false,
      fileList: [],
      page: 1,
      pageSize: 20,
      total: 0,
      pendingFiles: [],
      storeOptions: [],
      uploadingAll: false
    }
  },
  mounted() {
    this.projectId = this.$route.params.projectId
    this.loadFileList()
    this.loadStoreOptions()
  },
  methods: {
    goBack() {
      this.$router.push('/wodexiangmu/list')
    },
    async loadFileList() {
      this.loading = true
      try {
        const res = await axios.post('/StoreFile/list', {
            ProjectId: this.projectId,
            Page: this.page,
            PageSize: this.pageSize
        })
        this.fileList = (res.data || res).records || []
        this.total = (res.data || res).total || 0
      } catch (e) {
        console.error(e)
        this.fileList = []
      } finally {
        this.loading = false
      }
    },
    async loadStoreOptions() {
      // TODO: 调用获取门店列表API
      this.storeOptions = [
        { code: 'BJ001', name: '北京朝阳店' },
        { code: 'TJ001', name: '天津和平店' },
        { code: 'SJZ01', name: '石家庄裕华店' }
      ]
    },
    handleFileChange(file) {
      this.pendingFiles.push({
        name: file.name,
        size: file.size,
        raw: file.raw,
        storeCode: '',
        uploading: false
      })
    },
    removePending(index) {
      this.pendingFiles.splice(index, 1)
    },
    async uploadSingle(item, index) {
      if (!item.storeCode) {
        this.$message.warning('请先选择关联门店')
        return
      }
      
      item.uploading = true
      try {
        const store = this.storeOptions.find(s => s.code === item.storeCode)
        const formData = new FormData()
        formData.append('file', item.raw)
        formData.append('projectId', this.projectId)
        formData.append('storeCode', item.storeCode)
        formData.append('storeName', store?.name || '')
        
        await axios.upload('/StoreFile/upload', formData)
        
        this.$message.success('上传成功')
        this.pendingFiles.splice(index, 1)
        this.loadFileList()
      } catch (e) {
        console.error(e)
        this.$message.error('上传失败')
      } finally {
        item.uploading = false
      }
    },
    async uploadAll() {
      const unmatched = this.pendingFiles.filter(f => !f.storeCode)
      if (unmatched.length > 0) {
        this.$message.warning(`还有 ${unmatched.length} 个文件未关联门店`)
        return
      }
      
      this.uploadingAll = true
      for (let i = this.pendingFiles.length - 1; i >= 0; i--) {
        await this.uploadSingle(this.pendingFiles[i], i)
      }
      this.uploadingAll = false
    },
    async deleteFile(row) {
      try {
        await this.$confirm('确定要删除该文件吗？', '提示', { type: 'warning' })
        await axios.post('/StoreFile/delete', { Id: row.id })
        this.$message.success('删除成功')
        this.loadFileList()
      } catch (e) {
        if (e !== 'cancel') {
          console.error(e)
          this.$message.error('删除失败')
        }
      }
    },
    previewFile(row) {
      window.open(row.fileUrl, '_blank')
    },
    formatSize(bytes) {
      if (bytes < 1024) return bytes + ' B'
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB'
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB'
    },
    formatDate(date) {
      if (!date) return '-'
      return new Date(date).toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.file-distribution {
  padding: 20px;
}
.page-header {
  margin-bottom: 20px;
}
.action-bar {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}
.pending-files, .file-list {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}
.pending-files h4, .file-list h4 {
  margin: 0 0 16px;
  font-size: 16px;
  color: #333;
}
</style>
